import { supabase } from "@/integrations/supabase/client";
import { installTabAuthLock } from "./tab-auth-lock";

// Must be imported before anything else in main.tsx so no request waits on the shared lock.
installTabAuthLock(supabase.auth);
